import { analyzeItemType as analyzeItemTypeReq } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/http';
import { useErrorHandler, useExperiments, useHttpClient } from '@wix/fe-essentials/react';
import { assertNotOptional } from '@wix/seo-common-core';
import { useCallback } from 'react';
import { AnalysisState, usePanelStateAtom } from '../../hooks/rules-state';
import { useA11yDebug } from '../../hooks/use-a11y-debug';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
export const useAnalyzeItemType = () => {
  const httpClient = useHttpClient();
  const {
    a11yWizardAdapter
  } = useA11yWizardAdapter();
  const {
    withErrorHandler
  } = useErrorHandler();
  const {
    setGroupsAnalysisState,
    resetScanPageForAllItemType
  } = usePanelStateAtom();
  const a11yDebug = useA11yDebug();
  const {
    experiments
  } = useExperiments();
  const analyzeItemType = useCallback(async itemType => {
    setGroupsAnalysisState(AnalysisState.Analyzing, itemType);
    resetScanPageForAllItemType(itemType);
    try {
      if (!experiments.enabled('specs.a11y.A11yWizardRmVersion')) {
        await a11yWizardAdapter.triggerEditorSave();
      }
      const response = await withErrorHandler(async () => httpClient.request(analyzeItemTypeReq({
        itemType
      })), {
        errorCodesMap: {}
      });
      a11yDebug.addAnalyzeResponse == null || a11yDebug.addAnalyzeResponse(response);
      const {
        job
      } = response.data;
      assertNotOptional(job, 'job');
      return job;
    } catch (error) {
      setGroupsAnalysisState(AnalysisState.AnalyzeFailed, itemType);
      throw error;
    }
  }, [setGroupsAnalysisState, resetScanPageForAllItemType, a11yWizardAdapter, withErrorHandler, a11yDebug, httpClient, experiments]);
  return {
    analyzeItemType
  };
};
//# sourceMappingURL=use-analyze-item-type.js.map